import { useMutation, useQueryClient } from '@tanstack/react-query';
import { PhotoCategoryApi } from 'api';

export function useUpdatePhotoCategory({ onSuccess, onError } = {}) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['update-photo-category'],
    mutationFn: ({ id, ...data }) => PhotoCategoryApi.update(id, data),
    onSuccess: (data) => {
      queryClient.invalidateQueries(['photo-categories', data.vehicleId.toString()]);
      queryClient.invalidateQueries(['vehicle-photos', data.vehicleId.toString()]);
      typeof onSuccess === 'function' && onSuccess(data);
    },
    onError: (error) => {
      typeof onError === 'function' && onError(error);
    },
  });
}
